<template>
  <div class="my-account" v-show="isActive">
    <form>
      <div class="row">
        <div class="col-md-12">
          <section class="mb-5">
            <div class="flex-container space-between">
              <h4 class="section-title">Your personal details</h4>
              <button role="button" @click.prevent="edit(1)" class="cta-edit">
                Edit
              </button>
            </div>
            <hr class="solid" />
            <template v-if="isReadOnly">
              <div class="row field-wrapper">
                <div class="col-md-5 col-12">
                  <span class="label">Name</span>
                </div>
                <div class="col-md-7 col-12">
                  <span class="label-mute">{{ FirstName }}</span>
                </div>
              </div>
              <div class="row field-wrapper">
                <div class="col-md-5 col-12">
                  <span class="label">Email address</span>
                </div>
                <div class="col-md-7 col-12">
                  <span class="label-mute">{{ Email }}</span>
                </div>
              </div>
            </template>
            <template v-if="!isReadOnly & (section == 1)">
              <AlertMessages />
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      class="text-field-4"
                      id="firstName"
                      v-model="FirstName"
                      @blur="$v.FirstName.$touch()"
                      :class="{ 'is-invalid': $v.FirstName.$error }"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">First name</span>
                    </div>
                  </div>
                  <div v-if="$v.FirstName.$error" class="feedback">
                    <span v-if="!$v.FirstName.required"
                      >This field is required</span
                    >
                    <span v-if="!$v.FirstName.minLength"
                      >First name must be at least 2 characters</span
                    >
                    <span v-if="!$v.FirstName.maxLength"
                      >First name must be less than 100 characters</span
                    >
                    <span v-if="!$v.FirstName.characters"
                      >Characters and alphabets, hyphens and numbers are
                      allowed</span
                    >
                  </div>
                </div>
                
              </div>
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      type="text"
                      autocomplete="off"
                      class="text-field-4"
                      id="email"
                      v-model="Email"
                      @blur="$v.Email.$touch()"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">Email address</span>
                    </div>
                  </div>
                  <div v-if="$v.Email.$error" class="feedback">
                    <span v-if="!$v.Email.required"
                      >This field is required</span
                    >
                    <span v-if="!$v.Email.email && $v.Email.$dirty"
                      >Incorrect email format</span
                    >
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      type="text"
                      autocomplete="off"
                      class="text-field-4"
                      id="confirmEmail"
                      v-model="ConfirmEmail"
                      @blur="$v.ConfirmEmail.$touch()"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">Confirm email address</span>
                    </div>
                  </div>
                  <div v-if="$v.ConfirmEmail.$error" class="feedback">
                    <span v-if="!$v.ConfirmEmail.required"
                      >This field is required</span
                    >
                    <span
                      v-if="!$v.ConfirmEmail.email && $v.ConfirmEmail.$dirty"
                      >Incorrect email format</span
                    >
                    <span v-if="!$v.ConfirmEmail.sameAsEmail"
                      >Emails must match</span
                    >
                  </div>
                </div>
              </div>
              <div class="form-row cta-group">
                <button
                  role="button"
                  class="cta-white-169"
                  :disabled="!this.unsavedChanges"
                  @click="save(1)"
                >
                  Save changes
                  <span
                    class="angle-right-white"
                    v-show="!showSavedTick"
                  ></span>
                  <span class="check-right-white" v-show="showSavedTick"></span>
                </button>
                <button role="button" class="cta-cancel" @click="cancel(1)">
                  Cancel
                </button>
              </div>
            </template>
          </section>
          <section class="mb-5">
            <div class="flex-container space-between">
              <h4 class="section-title">Password</h4>
              <button role="button" @click.prevent="edit(2)" class="cta-edit">
                Edit
              </button>
            </div>
            <hr class="solid" />

            <template v-if="isReadOnly">
              <div class="form-row field-wrapper">
                <div class="col-12">
                  <span class="label password">Password</span>
                </div>
              </div>
            </template>
            <template v-if="!isReadOnly & (section == 2)">
              <AlertMessages />
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      type="password"
                      class="text-field-4"
                      id="password"
                      ref="password"
                      v-model="Password"
                      @blur="$v.Password.$touch()"
                      :class="{ 'is-invalid': $v.Password.$error }"
                    />
                    <i @click.prevent="showPassword(1)" :class="iconId"></i>
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">Current Password</span>
                    </div>
                  </div>
                  <div v-if="$v.Password.$error" class="feedback">
                    <span v-if="!$v.Password.required"
                      >This field is required</span
                    >
                    <span v-if="!$v.Password.minLength"
                      >Password must be at least 8 characters</span
                    >
                    <span v-if="!$v.Password.strongPassword"
                      >Password must contain a lowercase character, uppercase
                      character, a number and a special character</span
                    >
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper">
                    <input
                      type="password"
                      class="text-field-4"
                      id="newPassword"
                      v-model="NewPassword"
                      ref="newPassword"
                      @blur="$v.NewPassword.$touch()"
                      :class="{ 'is-invalid': $v.NewPassword.$error }"
                    />
                    <i @click.prevent="showPassword(2)" :class="iconNewId"></i>
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">New Password</span>
                    </div>
                  </div>
                  <div v-if="$v.NewPassword.$error" class="feedback">
                    <span v-if="!$v.NewPassword.required"
                      >This field is required</span
                    >
                    <span v-if="!$v.NewPassword.minLength"
                      >Password must be at least 8 characters</span
                    >
                    <span v-if="!$v.NewPassword.strongPassword"
                      >Password must contain a lowercase character, uppercase
                      character, a number and a special character</span
                    >
                  </div>
                  <p class="label-info">
                    Must be at least 8 characters and contain a lowercase
                    character, uppercase character, a number and a special
                    character.
                  </p>
                </div>
              </div>
              <div class="form-row cta-group">
                <button
                  role="button"
                  class="cta-white-169"
                  v-show="!showSavedTick"
                  :disabled="!this.unsavedChanges"
                  @click="save(2)"
                >
                  Save changes
                  <span
                    class="angle-right-white"
                    v-show="!showSavedTick"
                  ></span>
                  <span class="check-right-white" v-show="showSavedTick"></span>
                </button>
                <button role="button" class="cta-cancel" @click="cancel(2)">
                  Cancel
                </button>
              </div>
            </template>
          </section>
          <section class="mb-5">
            <div class="flex-container space-between">
              <h4 class="section-title">Organisation details</h4>
              <button role="button" @click.prevent="edit(3)" class="cta-edit">
                Edit
              </button>
            </div>
            <hr class="solid" />
            <template v-if="isReadOnly">
              <div class="row field-wrapper">
                <div class="col-md-5 col-12">
                  <span class="label">Role</span>
                </div>
                <div class="col-md-7 col-12">
                  <span class="label-mute">{{ Role }}</span>
                </div>
              </div>
              <div class="row field-wrapper">
                <div class="col-md-5 col-12">
                  <span class="label">Organisation</span>
                </div>
                <div class="col-md-7 col-12">
                  <span class="label-mute">{{ Organisation }}</span>
                </div>
              </div>
            </template>
            <template v-if="!isReadOnly & (section == 3)">
              <AlertMessages />
              
              <!-- <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper select-field-4" v-flyout>

                    <select
                      id="role"
                      v-model="Role"
                      @change="onChange($event)"
                      @blur="$v.Role.$touch()"
                      :class="{ 'is-invalid': $v.Role.$error }"
                      ><option
                        v-for="option in roles"
                        :key="option.value"
                        :value="option.value"
                        >{{ option.value }}</option
                      >
                    </select>

                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">Role</span>
                    </div>
                  </div>
                  <i v-if="!$v.Role.$error" class="fa fa-check"></i>
                  <div v-if="$v.Role.$error" class="feedback">
                    <span v-if="!$v.Role.required"
                      >This field is required</span
                    >
                  </div>
                </div>
              </div> -->

              
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      class="text-field-4"
                      id="Role"
                      v-model="Role"
                      @blur="$v.Role.$touch()"
                      :class="{ 'is-invalid': $v.Role.$error }"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="">Role</span>
                    </div>
                  </div>
                  <div v-if="$v.Role.$error" class="feedback">
                    <span v-if="!$v.Role.maxLength"
                      >Type of role must be less than 100 characters</span
                    >
                    <span v-if="!$v.Role.characters"
                      >Characters and alphabets, hyphens and numbers are
                      allowed</span
                    >
                  </div>
                </div>
              </div>
              

              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      class="text-field-4"
                      id="organ"
                      v-model="Organisation"
                      @blur="$v.Organisation.$touch()"
                      :class="{ 'is-invalid': $v.Organisation.$error }"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">Organisation</span>
                    </div>
                  </div>
                  <div v-if="$v.Organisation.$error" class="feedback">
                    <span v-if="!$v.Organisation.required"
                      >This field is required</span
                    >

                    <span v-if="!$v.Organisation.maxLength"
                      >Organisation must be less than 100
                      characters</span
                    >
                    <span v-if="!$v.Organisation.characters"
                      >Characters and alphabets, hyphens and numbers are
                      allowed</span
                    >
                  </div>
                </div>
              </div>

              <!-- <div v-if="Organisation === 'Other - please give details'">
                <div class="form-row">
                  <div class="col-12">
                    <div class="field-wrapper" v-flyout>
                      <input
                        class="text-field-4"
                        id="typeOfOrganisation"
                        v-model="TypeOfOrganisation"
                        @blur="$v.TypeOfOrganisation.$touch()"
                        :class="{ 'is-invalid': $v.TypeOfOrganisation.$error }"
                      />
                      <i class="fa fa-check"></i>
                      <div class="field-placeholder" v-animate>
                        <span class="">Type of organisation</span>
                      </div>
                    </div>
                    <div v-if="$v.TypeOfOrganisation.$error" class="feedback">
                      <span v-if="!$v.TypeOfOrganisation.maxLength"
                        >Type of organisation must be less than 100 characters</span
                      >
                      <span v-if="!$v.TypeOfOrganisation.characters"
                        >Characters and alphabets, hyphens and numbers are
                        allowed</span
                      >
                    </div>
                  </div>
                </div>
              </div> -->
              
              <div class="form-row cta-group">
                <button
                  role="button"
                  class="cta-white-169"
                  v-show="!showSavedTick"
                  :disabled="!this.unsavedChanges"
                  @click="save(3)"
                >
                  Save changes
                  <span
                    class="angle-right-white"
                    v-show="!showSavedTick"
                  ></span>
                  <span class="check-right-white" v-show="showSavedTick"></span>
                </button>
                <button role="button" class="cta-cancel" @click="cancel(3)">
                  Cancel
                </button>
              </div>
            </template>
          </section>
          <section class="mb-5">
            <div class="flex-container space-between">
              <h4 class="section-title">Keep up to date with the CPSU</h4>
              <button role="button" @click.prevent="edit(4)" class="cta-edit">
                Edit
              </button>
            </div>
            <hr class="solid" />
            <template v-if="isReadOnly">
              <div class="row">
                <div class="col-md-12 col-12">
                  <span class="label-mute">{{
                    EmailOptIn
                      ? "Yes, I would like to receive emails."
                      : "No, I don’t like to receive emails."
                  }}</span>
                </div>
              </div>
            </template>
            <template v-if="!isReadOnly & (section == 4)">
              <AlertMessages />
              <p class="keep-up">
                We would like to keep you informed about our professional
                training, events, latest news, services and resources that may
                be relevant to you. Please let us know whether you’re happy to
                receive our emails:
              </p>
              <div class="form-row">
                <label class="checkbox label-info" for="emailOptIn"
                  >Yes I would like to receive emails.
                  <input
                    type="checkbox"
                    class="label-info"
                    id="emailOptIn"
                    v-model="EmailOptIn"/><span class="checkmark"></span
                ></label>
              </div>
              <div class="form-row cta-group">
                <button
                  role="button"
                  class="cta-white-169"
                  v-show="!showSavedTick"
                  :disabled="!this.unsavedChanges"
                  @click="save(4)"
                >
                  Save changes
                  <span
                    class="angle-right-white"
                    v-show="!showSavedTick"
                  ></span>
                  <span class="check-right-white" v-show="showSavedTick"></span>
                </button>
                <button role="button" class="cta-cancel" @click="cancel(4)" >
                  Cancel
                </button>
              </div>
            </template>
          </section>
          <a role="button" tabindex="0" class="delete-link" @click="deleteAccount" @keydown.enter="deleteAccount"> Delete account</a>          
          <popup-modal ref="unsavedPopup">
            <p>
              You have not saved changes to your account. Are you sure you want
              to leave?
            </p>
            <div class="d-flex">
              <a role="button" tabindex="0" class="cancel mr-auto my-auto" @click="cancelPopup(true)" @keydown.enter="cancelPopup(true)"
                >Cancel</a
              >
              <button
                role="button"
                class="cta-green-169"
                @click="confirmPopup(true)"
                @keydown.enter="confirmPopup(true)"
              >
                OK<span class="angle-right-green"></span>
              </button>
            </div>
          </popup-modal>
        </div>
        <div class="space"></div>
      </div>
    </form>
    <popup-modal ref="popup">
      <p>
        Are you sure you want to delete all your account data and saved
        assessments?
      </p>
      <div class="d-flex">
        <a role="button" tabindex="0"  class="cancel mr-auto my-auto" @click="cancelPopup(false)"
        @keydown.enter="cancelPopup(false)"
          >Cancel</a
        >
        <button
          role="button"
          class="cta-green-205"
          @click="confirmDelete()"
          @keydown.enter="confirmDelete()"
        >
          Yes, delete account
        </button>
      </div>
    </popup-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import {
  required,
  email,
  sameAs,
  minLength,
  maxLength,
  helpers
} from "vuelidate/lib/validators";
import AlertMessages from "../components/alert-messages";
import { SET_USER } from "../store/mutation-types";
import PopupModal from "../components/popup-modal";
//import { publicRouter } from "../router";

// characters and alphabets, hyphens and numbers only
const characters = helpers.regex(
  "characters",
  /^[0-9a-zA-Z\u00C0-\u024F\u1E02-\u1EF3'\- ]+$/
);

export default {
  name: "OverviewMyAccount",
  components: { AlertMessages, PopupModal },

  validations() {
    if (this.section === 1) {
      return {
        FirstName: {
          required,
          maxLength: maxLength(100),
          minLength: minLength(2),
          characters
        },
        Email: {
          required,
          email
        },
        ConfirmEmail: {
          required,
          sameAsEmail: sameAs("Email")
        }
      };
    } else if (this.section === 2) {
      return {
        Password: {
          required,
          minLength: minLength(8),
          strongPassword: password => {
            if (
              typeof password == "undefined" ||
              password == null ||
              password == ""
            )
              return true;
            return (
              //password.length >= 8 &&
              /[a-z]/.test(password) &&
              /[A-Z]/.test(password) &&
              /[0-9]/.test(password) &&
              /[!@#$%^&*(),.?":{}|<>]/.test(password)
            );
          }
        },
        NewPassword: {
          required,
          minLength: minLength(8),
          strongPassword: password => {
            if (
              typeof password == "undefined" ||
              password == null ||
              password == ""
            )
              return true;
            return (
              // password.length >= 8 &&
              /[a-z]/.test(password) &&
              /[A-Z]/.test(password) &&
              /[0-9]/.test(password) &&
              /[!@#$%^&*(),.?":{}|<>]/.test(password)
            );
          }
        }
      };
    } else if (this.section === 3) {
      return {
        JobTitle: {
          maxLength: maxLength(100),
          characters
        },
        Role: {
          required
        },

        TypeOfRole: {
          customValidation(value, vm) {
             if (vm.Role === "Other - please give details")
        {
         return  value.length > 0;
        }
          return true;
            // if (typeof value == "undefined" || value == null || value == "")
            //   return true;
            // return value.length > 0 && vm.Role == "Education/School";
          }
        },
        Organisation: {
          required
        },
        TypeOfOrganisation: {
          customValidation(value, vm) {
            if (vm.Organisation === "Other - please give details")
            {
              return  value.length > 0;
            }
            return true;
          }
        }
      };
    }
    // else if (this.section ===4){
    // return {};
    // }
  },
  data() {
    return {
      isActive: true,
      isReadOnly: true,
      section: Number,
      roles: [],
      schools: [],
      showEyeIcon: false,
      showNewEyeIcon: false,
      resolvePromise: undefined,
      rejectPromise: undefined,
      showSavedTick: false,
      unsavedChanges: false,
      userDeleted: false
    };
  },
  props: {
    satContent: {
      type: Object,
      default: () => {}
    }
  },
  async created() {
    await this.getContent();
    if (this.content.Roles)
      this.roles = this.content.Roles.map(x => {
        return { value: x };
      });

    if (this.content.SchoolTypes)
      this.schools = this.content.SchoolTypes.map(x => {
        return { value: x };
      });
  },
  methods: {
    ...mapActions("alert", ["clear"]),
    ...mapActions("util", ["getContent"]),
    ...mapActions("users", ["updateUser", "logoutAndDeleteUser"]),
    ...mapActions("account", ["signout", "authenticateUserAction"]),
    onChange(event) {
      this.Role = event.target.value;
       if (this.Role !== "Education/School") {
         this.TypeOfSchool =null;
       }
    },
    showPassword(element) {
      // Password
      if (element === 1) {
        this.showEyeIcon = !this.showEyeIcon;
        if (this.$refs.password.type == "password") {
          this.$refs.password.type = "text";
        } else {
          this.$refs.password.type = "password";
        }
      } else {
        this.showNewEyeIcon = !this.showNewEyeIcon;
        if (this.$refs.newPassword.type == "password") {
          this.$refs.newPassword.type = "text";
        } else {
          this.$refs.newPassword.type = "password";
        }
      }
    },
    showPopup(unsaved) {
      if (unsaved) this.$refs.unsavedPopup.open();
      else this.$refs.popup.open();
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    async edit(selectedSection) {
      if (this.unsavedChanges) {
        const ok = await this.showPopup(true);
        if (ok) {
          this.unsavedChanges = false;
        } else return;
      }
      this.clear();
      if (selectedSection == 2) {
        this.Password = "";
        this.NewPassword = "";
      }
      this.section = selectedSection;
      this.isReadOnly = false;
    },
    async save(selectedSection) {
      this.section = selectedSection;
      this.isReadOnly = false;

      this.clear();

      // If a section doesn't have a validations we don't need to call $v
      if (selectedSection !== 4) {
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }
      }
      this.showSavedTick = true;
      this.$emit("changesSavedOrCancelledInAccount");

      await this.updateUser({ user: this.user, section: selectedSection });

      if (!this.hasError) {
        this.isReadOnly = true;
        this.showSavedTick = false;
        this.unsavedChanges = false;
      }
    },
    cancel(selectedSection) {
      this.section = selectedSection;
      this.isReadOnly = true;
      this.clear();
      this.$v.$reset();
      this.$emit("changesSavedOrCancelledInAccount");
    },
    deleteAccount() {
      this.unsavedChanges = false;
      this.showPopup(false);
    },

    async confirmDelete() {
      this.userDeleted = true; // used to prevent 'unsaved changes' popup
      this.unsavedChanges = false;   
      await this.logoutAndDeleteUser();  
      this.unsavedChanges = false;           
      window.location.href = window.location.origin + "/sports-safeguarding-tools-login/#/"; 
    },

    confirmPopup(unsaved) {
      if (unsaved) this.$refs.unsavedPopup.close();
      else this.$refs.popup.close();
      this.resolvePromise(true);
    },

    cancelPopup(unsaved) {
      if (unsaved) this.$refs.unsavedPopup.close();
      else this.$refs.popup.close();
      this.resolvePromise(false);
      // Or you can throw an error
      // this.rejectPromise(new Error('User cancelled the dialogue'))
    },
  },
  computed: {
    ...mapState("users", ["user"]),
    ...mapGetters("alert", ["hasError"]),
    ...mapState("util", ["content"]),
    iconId() {
      return this.showEyeIcon ? "eye-on" : "eye-off";
    },
    iconNewId() {
      return this.showNewEyeIcon ? "eye-on" : "eye-off";
    },

    Id: {
      get() {
        return this.user.Id;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Id: val });
      }
    },
    FirstName: {
      get() {
        return this.user.FirstName;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { FirstName: val });
      }
    },
    Email: {
      get() {
        return this.user.Email;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Email: val });
      }
    },
    ConfirmEmail: {
      get() {
        return this.user.ConfirmEmail;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { ConfirmEmail: val });
      }
    },
    Password: {
      get() {
        return this.user.Password;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Password: val });
      }
    },
    NewPassword: {
      get() {
        return this.user.NewPassword;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { NewPassword: val });
      }
    },
    Role: {
      get() {
        return this.user.Role;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Role: val });
      }
    },
    TypeOfRole: {
      get() {
        return this.user.TypeOfRole;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { TypeOfRole: val });
      }
    },
    Organisation: {
      get() {
        return this.user.Organisation;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Organisation: val });
      }
    },
    TypeOfOrganisation: {
      get() {
        return this.user.TypeOfOrganisation;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { TypeOfOrganisation: val });
      }
    },

    EmailOptIn: {
      get() {
        let val = this.user.EmailOptIn;
        if (val == undefined) val = false;
        return val;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { EmailOptIn: val });
      }
    }
  },
  watch: {
    user: {
      handler() {
        if(!this.userDeleted) { // prevent usaved changes popup when deleting user
          this.$emit("inputChangedInAccount");
          this.unsavedChanges = true;
        }        
      },
      deep: true
    }
  }
};
</script>

<style lang="sass" scoped></style>
